<small class="{{ customClasses }}" style="color: #343434 !important;">
    {{TextToShow()}}
</small>